
  import { computed, defineComponent, onMounted } from "vue";
  import { useStore } from "@/store";
  import { useRoute, useRouter } from "vue-router";
  import { ActionTypes } from "@/store/actions";
  // import CategorySelect from "@/components/CategorySelect.vue";
  // import SoundSelect from "@/components/SoundSelect.vue";
  // import Countdown from "@/components/Countdown.vue";
  import EventSwiper from "@/components/EventSwiper.vue";
  // import Modal from "@/components/Modal.vue";
  import { Campaign } from "@/store/state";
  
  // const mog = {
  //   question: "/se/mog_question.mp3",
  //   happy: "/se/mog_happy.mp3",
  // };
  
  export default defineComponent({
    name: "event-schedule",
    components: {
      // Countdown,
      EventSwiper,
      // CategorySelect,
      // SoundSelect,
      // Modal,
    },
    data() {
      return {
        settingsModal: false,
      };
    },
    props: {
      versionNum: {
        type: String,
        required: true,
      },
    },
    setup() {
      const store = useStore();
      const route = useRoute();
      const router = useRouter();
      const loading = computed(() => store.state.loading);
      const totalCount = computed(() => store.getters.totalVisibleCampaignCount);
      const reset = computed(() => store.state.reset);
      const selectedVersions = computed(() => store.state.regions);
      const selectedSections = computed(() => store.state.sections);
      // const sound = computed(() => store.state.sound);
      const selectedCategories = computed(() => store.state.categories);
      const totalCategories = computed(() => store.getters.totalCategories);
      const totalVersions = computed(() => store.getters.totalVersions);
      const totalSections = computed(() => store.getters.totalSections);
      const data = computed(() => store.state.data);
  
      const allCategories = [
        "Maintenance",
        "Main Story",
        "Character Event",
        "Lost Chapter",
        "Intersecting Wills",
        "Heretic Event",
        "Raid Challenge",
        "Mission Dungeon",
        "Abyss Event",
        "Dimensions' End",
        "World of Illusions",
        "Boss Rush",
        "Campaign",
        "Campaign Draws",
        "Challenge Event",
        "Daily / Hunts",
        "6-Warrior Quest",
      ];
  
      const allVersions = ["Japan", "Global"];
  
      const allSections = ["Ongoing", "Future"];
  
      const availableVersions = ["jp", "gl"];
  
      // const allOrders = ["Start Date", "End Date", "Most Relevant Date"];
  
      onMounted(() => {
        store.dispatch(ActionTypes.GetData);
        store.dispatch(ActionTypes.RefreshReset);
  
        if (totalCategories.value === 0) {
          store.dispatch(
            ActionTypes.ToggleCategories,
            allCategories
          );
        }
  
        if (selectedVersions.value.length === 0) {
          store.dispatch(
            ActionTypes.ToggleVersion,
            allVersions.map((v, i) => i + 1)
          );
        }
  
        if (totalSections.value === 0) {
          store.dispatch(
            ActionTypes.ToggleSection,
            allSections.map((s, i) => i + 1)
          );
        }
      });
  
      // const playSound = () => {
      //   const audio =
      //     Math.random() < 0.5 ? new Audio(mog.question) : new Audio(mog.happy);
      //   if (sound.value) audio.play();
      // };
  
      const toggleVersion = () => {
        switch (route.params.version) {
          case availableVersions[0]:
            router.push("/gl");
            break;
          case availableVersions[1]:
            router.push("/");
            break;
          default:
            router.push("/jp");
            break;
        }
        // store.dispatch(
        //   ActionTypes.ToggleVersion,
        //   selectedVersions.value.length !== 1 || selectedVersions.value[0] === 1
        //     ? [2]
        //     : [1]
        // );
      };
  
      const selectCategory = (value: string) => {
        switch (value) {
          default:
            if (selectedCategories.value.find((c) => c === value))
              store.dispatch(
                ActionTypes.ToggleCategories,
                selectedCategories.value.filter((c) => c !== value)
              );
            else
              store.dispatch(ActionTypes.ToggleCategories, [
                ...selectedCategories.value,
                value,
              ]);
            break;
        }
      };
  
      const selectVersion = (value: number) => {
        switch (value) {
          default:
            if (selectedVersions.value.find((c) => c === value))
              store.dispatch(
                ActionTypes.ToggleVersion,
                selectedVersions.value.filter((c) => c !== value)
              );
            else
              store.dispatch(ActionTypes.ToggleVersion, [
                ...selectedVersions.value,
                value,
              ]);
            break;
        }
      };
  
      const selectSection = (value: number) => {
        switch (value) {
          default:
            if (selectedSections.value.find((c) => c === value))
              store.dispatch(
                ActionTypes.ToggleSection,
                selectedSections.value.filter((c) => c !== value)
              );
            else
              store.dispatch(ActionTypes.ToggleSection, [
                ...selectedSections.value,
                value,
              ]);
            break;
        }
      };
  
      const hasExpired = (event: Campaign) => {
        if (event.out_date.length > 0) {
          return new Date(event.out_date.replace(/\s/g, "T")) < new Date();
        }
        return new Date(event.in_date.replace(/\s/g, "T")) < new Date();
      };
  
      // const active = (list: Campaign[]) => {
      //   return list.filter((l) => !hasExpired(l));
      // };
  
      const activeTimers = computed(() => {
        return data.value.filter((l) => !hasExpired(l));
      });
  
      return {
        hasExpired,
        activeTimers,
        loading,
        route,
        data,
        reset,
        // playSound,
        selectedCategories,
        selectedSections,
        selectedVersions,
        selectCategory,
        selectSection,
        selectVersion,
        toggleVersion,
        allCategories,
        allSections,
        availableVersions,
        // allOrders,
        allVersions,
        totalCount,
        totalCategories,
        totalSections,
        totalVersions,
      };
    },
    mounted() {
      document.body.classList.add("bg-light");
    },
    unmounted() {
      document.body.classList.remove("bg-light");
    },
  });
  